export const Filters = {
    tag: 'tag',
    PSP: 'PSP'
};
